<div class="flex h-dvh flex-col items-center justify-center bg-emerald-50">
  <h1 class="text-text-primary font-family-din mb-8 text-6xl font-bold">{{ title() }}</h1>
  <div [class]="class()">
    <ng-content></ng-content>
  </div>

  @if (previousRoute(); as previous) {
    <div class="pointer-events-none absolute top-1/2 flex w-full -translate-y-1/2 justify-between p-8">
      <rid-chevron class="pointer-events-auto cursor-pointer" direction="LEFT" (click)="$router.navigate([previous])" />
    </div>
  }
</div>
